import type { SessionSlot, LocationGroup, SessionStatus } from '@features/customization-session/types';

export interface StatusStep {
  value: SessionStatus;
  /** Short label for the stepper. */
  step: string;
  /** Full label for the status chip. */
  label: string;
  color: 'default' | 'info' | 'warning' | 'primary' | 'success';
}

export const STATUS_STEPS: StatusStep[] = [
  { value: 'to_load', step: 'Gabarit', label: 'Produits à mettre dans le gabarit', color: 'warning' },
  { value: 'pdf', step: 'PDF', label: 'PDF de personnalisation à récupérer', color: 'warning' },
  { value: 'export', step: 'Export', label: 'Fichiers de production à exporter', color: 'primary' },
  { value: 'ready', step: 'Machine', label: 'Dans la machine, prêt à personnaliser', color: 'info' },
  { value: 'in_progress', step: 'Personnalisation', label: 'Personnalisation en cours', color: 'primary' },
  { value: 'customized', step: 'Rangement', label: 'Personnalisé, produits à ranger', color: 'warning' },
  { value: 'stored', step: 'Terminé', label: 'Rangé, plus aucune action à faire', color: 'success' },
];

export const getStatusStep = (status: SessionStatus): StatusStep =>
  STATUS_STEPS.find((step) => step.value === status) ?? STATUS_STEPS[0];

/**
 * Groups the products by the box they come from, ordered like the jig numbers: the operator takes the products box by
 * box (and puts them back box by box), each one going on the number shown.
 */
export const groupByLocation = (slots: SessionSlot[]): LocationGroup[] => {
  const groups = new Map<string, LocationGroup>();

  slots.forEach((slot) => {
    const key = `${slot.workshop ?? ''}|${slot.box ?? ''}`;
    const group = groups.get(key) ?? { key, workshop: slot.workshop, box: slot.box, slots: [] };
    group.slots.push(slot);
    groups.set(key, group);
  });

  return [...groups.values()];
};
